import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { SquadFiltrosCriteria } from "@workflow/types";

import { squadService } from "@/services/api/squad.service";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;
const ESTATISTICAS_STALE = 5 * MINUTE;

/**
 * Query keys do domínio "squads". `list` mantém a key legada `['squads-list']` — a
 * mesma que `useSquadActions` invalida —, então as mutações existentes continuam
 * alcançando esta lista.
 */
export const squadKeys = {
  list: ["squads-list"] as const,
  filtros: ["squads-filtros"] as const,
  estatisticas: ["squads-estatisticas"] as const,
};

export const squadQueries = {
  list: (criteria: SquadFiltrosCriteria) =>
    queryOptions({
      queryKey: [...squadKeys.list, criteria],
      queryFn: () => squadService.listSquads(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: squadKeys.filtros,
      queryFn: () => squadService.getFiltros(),
      staleTime: FILTROS_STALE,
    }),

  estatisticas: () =>
    queryOptions({
      queryKey: squadKeys.estatisticas,
      queryFn: () => squadService.getEstatisticas(),
      staleTime: ESTATISTICAS_STALE,
    }),
};
